module.exports = __webpack_public_path__ + "static/media/filter.6ba13c98.svg";